<template>
  <div @click="toggleSidebar">
    <fade-transition :duration="200" origin="center top" mode="out-in">
      <!-- your content here -->
      <router-view></router-view>
    </fade-transition>
    <content-footer v-if="!$route.meta.hideFooter"></content-footer>
  </div>
</template>
<script>

  import ContentFooter from './Footer';
  import {FadeTransition} from 'vue2-transitions';
  export default {
    components: {
      FadeTransition,
      ContentFooter
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      }
    }
  };
</script>
